// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DatapointsExcelRequestSpecifics1FromJSON, DatapointsExcelRequestSpecifics1ToJSON, DatapointsRequestBaseFromJSON, DatapointsRequestBaseToJSON, } from './';
export function DatapointsFiltersRequestFromJSON(json) {
    return {
        ...DatapointsExcelRequestSpecifics1FromJSON(json),
        ...DatapointsRequestBaseFromJSON(json),
    };
}
export function DatapointsFiltersRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        ...DatapointsExcelRequestSpecifics1ToJSON(value),
        ...DatapointsRequestBaseToJSON(value),
    };
}
